// import { getFileFormatErrorTemplate } from 'home/view/check-feasibility/comp-generator/component.generator';
import React from 'react';

import { getFromSessionStorage, getBulkUpgradeDownloadError, findParamFromUrl, getOrderDetails } from 'common/utils/app.utils';

import { sampleDownload, bulkUploadAddressResolution, downloadErrorSheet, downloadUpgradeEmptyTemplate, cancelLead } from 'home/view/manage-feasibility/services';
import { downloadFileURI, getFileName } from 'home/view/manage-feasibility/utils';
import { MULTI_SITE_MODULE_ID, AUTH_TOKEN, LEAD_ID, FILE_UPLOAD_PAGES, DEFAULT_TOAST_MSG, ERROR_TOAST } from 'home/view/manage-feasibility/constants';
import { DEDICATED_COMMON_PARAMS, isBulkUpgrade, ROUTES } from 'common/constants/app.constants';
import { getCurrentLead } from 'tokenGeneration/lead.util';

type DownloadSampleFileArgs = {
  isdedicatedJourney: boolean;
  setToast: (show: boolean, message: any, type: string) => void;
  setIsDownloadDisabled: React.Dispatch<React.SetStateAction<boolean>>;
};

interface UploadFileArgs {
  file: any;
  abortController?: AbortController;
  // For UT: msw setupServer doesnot support onUploadProgress event -> error: request.upload.addEventListener is undefined
  // onUploadProgress?: (progressPercentage: ProgressEventType) => void;
  onUploadProgress?: any;
}

export const downloadSampleFile = async ({ isdedicatedJourney, setToast, setIsDownloadDisabled }: DownloadSampleFileArgs): Promise<any> => {
  try {
    setIsDownloadDisabled(true);
    const { res, err } = await sampleDownload(isdedicatedJourney);
    if (res) {
      const { data } = res;

      const serviceType = DEDICATED_COMMON_PARAMS.serviceType;
      const fileName = getFileName(res, `Sample_${serviceType}.xlsx`);
      downloadFileURI(data, fileName);
      setIsDownloadDisabled(false);
    } else if (err) {
      let errorMsg = err?.response?.data?.errorMsg || DEFAULT_TOAST_MSG;

      if (isBulkUpgrade()) {
        errorMsg = await getBulkUpgradeDownloadError(err);
      }

      setIsDownloadDisabled(false);
      setToast(true, errorMsg, ERROR_TOAST);
      throw new Error(errorMsg);
    }
  } catch (e) {
    setIsDownloadDisabled(false);
    console?.error(e);
  }
};

export const downloadUpgradeTemplate = async ({ isdedicatedJourney, setToast, setIsDownloadDisabled }: DownloadSampleFileArgs): Promise<any> => {
  try {
    setIsDownloadDisabled(true);
    const { res, err } = await downloadUpgradeEmptyTemplate(isdedicatedJourney);
    if (res) {
      const { data } = res;
      const serviceType = DEDICATED_COMMON_PARAMS.serviceType;
      const fileName = getFileName(res, `Sample_${serviceType}.xlsx`);
      downloadFileURI(data, fileName);
      setIsDownloadDisabled(false);
    } else if (err) {
      let errorMsg = err?.response?.data?.errorMsg || DEFAULT_TOAST_MSG;

      if (isBulkUpgrade()) {
        errorMsg = await getBulkUpgradeDownloadError(err);
      }

      setIsDownloadDisabled(false);
      setToast(true, errorMsg, ERROR_TOAST);
      throw new Error(errorMsg);
    }
  } catch (e) {
    setIsDownloadDisabled(false);
    console?.error(e);
  }
};

export const downloadErrorFile = async (errorSheetUrl: string, setToast: (show: boolean, message: string, type: string) => void): Promise<any> => {
  try {
    const leadId = getFromSessionStorage?.(MULTI_SITE_MODULE_ID, LEAD_ID);
    const leadAuthToken = getFromSessionStorage?.(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

    const { res, err } = await downloadErrorSheet?.(errorSheetUrl, leadAuthToken, leadId);

    if (res) {
      const { data } = res;
      const serviceType = DEDICATED_COMMON_PARAMS.serviceType;
      const fileName = getFileName?.(res, `Error_Sample_Bulk_Upload_Feasibility_${serviceType}.xlsx`);
      downloadFileURI?.(data, fileName);
    } else if (err) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
      setToast(true, errorMsg, ERROR_TOAST);
      throw new Error(errorMsg);
    }
  } catch (e) {
    console?.error(e);
  }
};

export const uploadFile = ({ file, abortController, onUploadProgress }: UploadFileArgs): any => {
  const abortSignal = abortController?.signal;

  const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

  const formData = new FormData();
  formData.append('file', file);

  return bulkUploadAddressResolution(formData, leadAuthToken, onUploadProgress, FILE_UPLOAD_PAGES.SAMPLE_DOWNLOAD, abortSignal);
};

export const deleteLead = async (remarks: string, isdedicatedJourney: boolean, setToast: (show: boolean, message: string, type: string) => void, history: any) => {
  try {
    const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);
    const reqData = {
      remarks
    };
    const { res, err } = await cancelLead(reqData, leadAuthToken, isdedicatedJourney);
    if (res) {
      const { data: { success = false } = {} } = res;
      if (success) {
        setToast(false, '', '');
        const partyId = findParamFromUrl('partyId', false);
        const leadId = getCurrentLead()?.leadId;
        let redirectUrl = ROUTES.DEDICATED_CANCEL;
        if (partyId) {
          redirectUrl = redirectUrl + '?partyId=' + partyId;
        }
        history && history.push(redirectUrl, { ...getOrderDetails(leadId), isUpgrade: isBulkUpgrade() });
      }
    } else if (err) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
      setToast(true, errorMsg, ERROR_TOAST);
      throw new Error(errorMsg);
    }
  } catch (e) {
    console.error(e);
  }
};
